export default "__VITE_ASSET__7WFTXp77__"